<script>
import { inject } from 'vue'
import { mapState } from 'vuex'
import BaseOverlayToggle from './BaseOverlayToggle.vue'

export default {
  name: 'AppCartToggle',

  components: { BaseOverlayToggle },

  setup () {
    const shopifyData = inject('shopifyData')
    return { shopifyData }
  },

  computed: {
    ...mapState({
      cart: 'cart',
      cartIsInitialized: 'cartIsInitialized',
      currentOverlay: 'currentOverlay'
    }),

    itemCountLabel () {
      return this.cart.item_count > 0 ? `: ${this.cart.item_count}` : ''
    },

    isHidden () {
      return this.currentOverlay !== 'cart' && this.cart.item_count < 1 || !this.cartIsInitialized
    }
  }
}
</script>

<template>
  <BaseOverlayToggle
    name="cart"
    :class="{
      'is-loaded': cartIsInitialized,
      'overlay-toggle--is-hidden': isHidden }"
  >
    <span v-if="window.theme.language.templates.cart.cart">{{
      window.theme.language.templates.cart.cart
    }}</span>
    <span v-if="cartIsInitialized">{{
      itemCountLabel
    }}</span>
  </BaseOverlayToggle>
</template>